import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { RUN_PRIORITY_PRESETS } from "shared/Run/priorityPresets";
import useSetRunPriority from "shared/Run/useSetRunPriority";
import { RunPriorityPreset } from "types/generated";

import { useModifyRunErrorHandler } from "./useModifyRunError";

const useSetPriority = () => {
  const onError = useModifyRunErrorHandler();
  const { reportSuccess } = useTypedContext(FlashContext);

  const [setRunPriority] = useSetRunPriority({ onError });

  const handleSetPriority = useCallback(
    (preset: RunPriorityPreset, runId: string, stackId: string) =>
      setRunPriority({ preset, run: runId, stack: stackId }, (data) => {
        if (data?.runPrioritySet) {
          const { label } = RUN_PRIORITY_PRESETS[data.runPrioritySet.priorityPreset];

          reportSuccess({ message: `Run ${runId} was set to ${label}` });
        }
      }),
    [setRunPriority, reportSuccess]
  );

  return {
    setPriority: handleSetPriority,
  };
};

export default useSetPriority;
